import React, { useEffect, useState } from "react";
import API_URL from "../../services/api";
import "./Dashboard.css";

const Dashboard = () => {
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchDashboard = async () => {
    try {
      setLoading(true);
      setError("");

      const token = localStorage.getItem("token");

      const res = await fetch(`${API_URL}/api/dashboard`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!res.ok) {
        throw new Error(`Server returned ${res.status}`);
      }

      const data = await res.json();
      setStats(data);
    } catch (err) {
      console.error("Dashboard error:", err);
      setError("Unable to load dashboard statistics.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);

  const cards = [
    {
      title: "Total Books",
      value: stats.totalBooks || 0,
      icon: "📚",
      color: "#2563EB",
    },
    {
      title: "Books For Sale",
      value: stats.booksForSale || 0,
      icon: "🛒",
      color: "#16A34A",
    },
    {
      title: "Library Books",
      value: stats.booksNotForSale || 0,
      icon: "🏛️",
      color: "#7C3AED",
    },
    {
      title: "Total Orders",
      value: stats.totalBooksSold || 0,
      icon: "💰",
      color: "#EA580C",
    },
    {
      title: "Delivered Orders",
      value: stats.deliveredOrders || 0,
      icon: "📦",
      color: "#059669",
    },
    {
      title: "Pending Orders",
      value: stats.pendingOrders || 0,
      icon: "⏳",
      color: "#D97706",
    },
    {
      title: "Verified Orders",
      value: stats.verifiedOrders || 0,
      icon: "✅",
      color: "#0284C7",
    },
    {
      title: "Rejected Orders",
      value: stats.rejectedOrders || 0,
      icon: "❌",
      color: "#DC2626",
    },
    {
      title: "Users",
      value: stats.totalUsers || 0,
      icon: "👥",
      color: "#6366F1",
    },
    {
      title: "Librarians",
      value: stats.totalLibrarians || 0,
      icon: "📖",
      color: "#9333EA",
    },
    {
      title: "Staff Members",
      value: stats.totalStaff || 0,
      icon: "👨‍💼",
      color: "#0F766E",
    },
  ];

  if (loading) {
    return (
      <div className="dashboard-container">
        <div className="dashboard-loading">
          <div className="loading-spinner"></div>
          <p>Loading dashboard...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="dashboard-container">
        <div className="dashboard-error">
          <div className="error-icon">⚠️</div>

          <h2>Dashboard Unavailable</h2>

          <p>{error}</p>

          <button
            className="retry-button"
            onClick={fetchDashboard}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <div>
          <h1>Admin Dashboard</h1>
          <p>Overview of your library management system</p>
        </div>
      </div>

      <div className="dashboard-cards">
        {cards.map((card, index) => (
          <div
            key={index}
            className="dashboard-card"
            style={{
              borderTop: `5px solid ${card.color}`,
            }}
          >
            <div
              className="dashboard-icon"
              style={{
                backgroundColor: `${card.color}15`,
              }}
            >
              {card.icon}
            </div>

            <div className="dashboard-value">
              {card.value}
            </div>

            <div className="dashboard-title">
              {card.title}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;